import { Api } from "../config/request";

export default {
  isUserValid() {
    return Api.get("/training-dashboard/is-valid-user");
  },
};
